var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._g(_vm._b({attrs:{"locale":'fr'},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_vm._t("item",null,{"item":item})]}},{key:"expanded-item",fn:function(ref){
var item = ref.item;
return [_vm._t("expanded-item",null,{"item":item})]}}],null,true)},'v-data-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }